import { Title, Texts, Media, Button } from "../Object";
import { Space } from "../Layout";
import { Link } from "react-router-dom"

const LinkBanner = () => {
  return (
    <>
      <div className="l-row">
        <div className="p-box__banner--link">
          {/* recruit */}
          <Link to="/recruit" className="p-title__wrap--link">
            <div className="p-box__banner--link__recruit">
              <div>
                <Title slug="recruit" type="row" />
                <Space size={['64px 0 0 ', '48px 0 0']}>
                  <Texts slug="button/recruit-body"></Texts>
                </Space>
              </div>
              <Media class="p-box__banner--link__recruit__img" src="recruit/button" alt="media" />
            </div>
          </Link>

          <div className="p-box__banner--link__right">
            {/* company */}
            <Link to="/company" className="p-title__wrap--link">
              <div className="p-box__banner--link__inner">
                <Title slug="company" type="row" />
              </div>
            </Link>
            {/* contact */}
            <Link to="/contact" className="p-title__wrap--link">
              <div className="p-box__banner--link__inner">
                <Title slug="contact" type="row" />
              </div>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default LinkBanner;